export const flags = {
    SEGMENTATION_CLIENT_MANAGED: 'LXP.SEGMENTATION.CLIENT_MANAGED.ENABLED',
    SEGMENTATION_LOCALES: 'LXP.SEGMENTATION.LOCALES.ENABLED',
    SEGMENTATION_COMPANY_RELATIONSHIP: 'LXP.SEGMENTATION.COMPANY_RELATIONSHIP.ENABLED',
    SEGMENTATION_PRODUCT: 'LXP.SEGMENTATION.PRODUCTS.ENABLED',
    SEGMENTATION_LEARNING_PROFILES: 'LXP.SEGMENTATION.LEARNING_PROFILES.ENABLED',
    SEGMENTATION_CLIENT_MANAGED_ATTRIBUTES_ENABLED: 'LXP.SEGMENTATION.CLIENT_MANAGED.ATTRIBUTES.ENABLED',
    BRANDS: 'LXP.BRANDS.ENABLED',
    CATEGORIES: 'LXP.CATEGORIES.ENABLED',
    CURRICULA: 'LXP.CURRICULA.ENABLED',
    CERTIFICATES: 'LXP.CERTIFICATES.ENABLED',
    DEMO: 'LXP.WIDGET.DEMO.ENABLED',
    DATA_EXPORT: 'LXP.DATA_EXPORT.ENABLED',
    RESOURCES: 'LXP.RESOURCES.ENABLED',
    COURSE_POINTS: 'LXP.COURSE_POINTS.ENABLED',
    SETTINGS_CALLBACKS: 'LXP.CALLBACKS.COURSE_COMPLETION.ENABLED',
    SCORMANDFILE: 'LXP.UPLOAD_SCORM_OR_FILE',
    SHOWPROXY: 'LXP.UPLOAD_PROXY',
    COPYPASTEHTML: 'LXP.COPYPASTEHTML.ENABLED',
    NOTIFICATIONS: 'LXP.NOTIFICATIONS.ENABLED',
    BRANDS_USER_RELATIONSHIP_REQUIRED: 'BRANDS_USER_RELATIONSHIP_REQUIRED',
    USE_TINY_MCE: 'USE_TINY_MCE',
    USE_TINY_MCE_AI: 'USE_TINY_MCE_AI',
    PAGE_SETUP: 'LXP.PAGE_SETUP.ENABLED',
    COURSE_GRID_ENABLED: 'LXP.HOMEPAGE.COURSES.LIST.ENABLED',
    CURRICULA_GRID_ENABLED: 'LXP.HOMEPAGE.CURRICULUMS.GRID.ENABLED',
    SHOW_CONTENT_MASTER_REPORT: 'LXP.SHOW_CONTENT_MASTER_REPORT',
    OBJECTIVES: 'LXP.OBJECTIVES.ENABLED',
    CERTIFICATES_OVERRIDE: 'LXP.CERTIFICATES.OVERRIDES.ENABLED',
    CURRICULA_WEIGHT_ENABLED: 'LXP.CURRICULA.WEIGHT.ENABLED',
    ROSTER_EDIT_ENABLED: 'LXP.ROSTER.EDIT.ENABLED',
    ILT_ENABLED: 'LXP.ILT.ENABLED',
    AI_REPORTING_ENABLED: 'LXP.REPORTING.AI.ENABLED',
    STATIC_REPORTING_ENABLED: 'LXP.REPORTING.STATIC.ENABLED',
    LEADERBOARDS: 'LXP.LEADERBOARDS.ENABLED',
    URL_RESOURCE_ENABLED: 'LXP.RESOURCE.URL.ENABLED',
    BADGES: 'LXP.BADGES.ENABLED',
    POINTS_REWARD_ENABLED: 'LXP.OBJECTIVES.REWARD.POINTS.ENABLED',
    CREDITS_REWARD_ENABLED: 'LXP.OBJECTIVES.REWARD.CREDITS.ENABLED',
    BADGES_REWARD_ENABLED: 'LXP.OBJECTIVES.REWARD.BADGES.ENABLED',
    SEQUENTIAL_COURSES: 'LXP.COURSES.SEQUENTIAL.ENABLED',
};

export const DEFAULT_COMPANY_VARIABLES = {
    [ flags.BRANDS ]: false,
    [ flags.CATEGORIES ]: false,
    [ flags.CERTIFICATES ]: false,
    [ flags.COURSE_POINTS ]: false,
    [ flags.CURRICULA ]: false,
    [ flags.DATA_EXPORT ]: true,
    [ flags.DEMO ]: false, 
    [ flags.NOTIFICATIONS ]: true, 
    [ flags.RESOURCES ]: false,
    [ flags.SCORMANDFILE ]: false, 
    [ flags.SEGMENTATION_CLIENT_MANAGED ]: true,
    [ flags.SEGMENTATION_CLIENT_MANAGED_ATTRIBUTES_ENABLED ]: false,
    [ flags.SEGMENTATION_COMPANY_RELATIONSHIP ]: false,
    [ flags.SEGMENTATION_LEARNING_PROFILES ]: false,
    [ flags.SEGMENTATION_LOCALES ]: false,
    [ flags.SEGMENTATION_PRODUCT ]: false,
    [ flags.SETTINGS_CALLBACKS ]: false, 
    [ flags.SCORMANDFILE ]: false, 
    [ flags.SHOWPROXY ]: false,
    [ flags.COPYPASTEHTML ]: false, 
    [ flags.BRANDS_USER_RELATIONSHIP_REQUIRED ]: true,
    [ flags.USE_TINY_MCE ]: true,
    [ flags.USE_TINY_MCE_AI ]: false,
    [ flags.PAGE_SETUP ]: true,
    [ flags.COURSE_GRID_ENABLED ]: false,
    [ flags.CURRICULA_GRID_ENABLED ]: false,
    [ flags.SHOW_CONTENT_MASTER_REPORT ]: true,
    [ flags.OBJECTIVES ]: false,
    [ flags.CERTIFICATES_OVERRIDE ]: false,
    [ flags.CURRICULA_WEIGHT_ENABLED ]: false,
    [ flags.ROSTER_EDIT_ENABLED ]: false,
    [ flags.AI_REPORTING_ENABLED ]: false,
    [ flags.ILT_ENABLED ]: false,
    [ flags.STATIC_REPORTING_ENABLED ]: false,
    [ flags.URL_RESOURCE_ENABLED ]: false,
    [ flags.BADGES ]: false,
    [ flags.BADGES_REWARD_ENABLED ]: false,
    [ flags.POINTS_REWARD_ENABLED ]: false,
    [ flags.CREDITS_REWARD_ENABLED ]: false,
    [ flags.SEQUENTIAL_COURSES ]: false,
};
